import {
  IUploadLogCustomFilter,
  IUploadLogCustomFilterInput,
  IUploadLogFilter,
} from '~/client/graph/types.generated'

export default class CustomUploadLogFilter implements IUploadLogCustomFilter {
  public static fromDto(dto: IUploadLogCustomFilter) {
    const filtersByFilterType = dto.filtersByFilterType.map(
      ({ type, values }) => ({
        type,
        values: values || [],
      }),
    )

    return new CustomUploadLogFilter(
      dto.id,
      dto.name,
      dto.isPublic,
      dto.projectId,
      dto.userId,
      dto.defaultForUsers,
      filtersByFilterType,
      dto.groupBy,
    )
  }

  public constructor(
    public id: string,
    public name: string,
    public isPublic: boolean,
    public readonly projectId: string,
    public readonly userId: string,
    public readonly defaultForUsers: string[],
    public readonly filtersByFilterType: IUploadLogFilter[] = [],
    public readonly groupBy: string,
  ) {}

  public toInput(): IUploadLogCustomFilterInput {
    return this
  }
}
